export default "__VITE_ASSET__wngNk3M8__"